import React, { useCallback } from "react";
import PropTypes from "prop-types";
import TaskForm from "./TaskForm";
import { Modal, ModalTitle } from "@td/ui";
import { translate } from "@td/shared_utils";
import { createTask } from "../apis";
import { mapValuesToFormData } from "../utils/tasks"
import { defaultTaskFormValues } from "../constants";
import toastr from "../../toastr";
import { useTasks } from "../contexts/tasks-context";

const CreateTaskModal = React.memo(({ isOpen, onClose }) => {
  const { fetchTasks } = useTasks();

  const handleSubmit = useCallback(async (values) => {
    const { success } = await createTask(
      mapValuesToFormData(values)
    );

    if (success) {
      fetchTasks();

      toastr.success(
        translate(null, "care_team_tasks.notifications", "task_added")
      );

      onClose();
    }
  }, [onClose, fetchTasks]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={translate(null, "care_team_tasks.create_task_modal", "title")}
    >
      <ModalTitle
        title={translate(null, "care_team_tasks.create_task_modal", "title")}
      />

      <TaskForm
        initialValues={defaultTaskFormValues}
        onSubmit={handleSubmit}
        buttonText={translate(null, "care_team_tasks.form", "create_task")}
      />
    </Modal>
  );
});

CreateTaskModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CreateTaskModal;
